<template>
  <v-dialog v-model="dialogShow" persistent width="800" class="dialog">
    <v-card>
      <v-card-title class="dialogTitle">
        <p class="dialogTitle-title">数据导出</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="height:578px;padding:22px 0 28px 0;display:flex;flex-direction:column;">

        <p style="padding-left:38px;padding-bottom:10px;font-size:16px;color:#808080;">选择要导出的标记-仅支持导出基本信息</p>

        <div v-if="contentInit" id="exportFolderDataTree" class="markerFolderDataTree myScrollArea">
          <v-treeview v-model="chooseItem"
                      open-all
                      selectable selected-color="#2A82E4"
                      :items="contentList" dense style="font-size:14px;"
          >

            <!--名称前图标-->
            <template v-slot:prepend="{ item, open }">
              <!--文件夹 class prependIconFolder作为标识-->
              <p v-if="item.type === 'folder'" style="margin-left:5px;color:#69AFFF;font-size:16px;" class="prependIconFolder iconfontFamily">&#xe64d;</p>
              <!--根目录 名称前图标-->
              <p v-else-if="item.type === 'root'" style="margin-left:5px;"></p>
              <!--普通标记-->
              <p v-else style="margin-left:5px;color:#a6a6a6;font-size:16px;" class="iconfontFamily" v-html="$utils.getPrependIconByType(item.type)"></p>
            </template>

            <!--标识/文件夹 后面的内容-->
            <template v-slot:append="{ item, open }">
              <p :style="{'font-weight':item.type ==='root'?'bold':'normal'}" style="margin-top: 2px;">{{getTypeTextByType(item.type)}}</p>
            </template>

            <!--标识/文件夹 名称-->
            <template v-slot:label="{ item, open }">
              <p :style="{'font-weight':item.type ==='root'?'bold':'normal'}" style="margin-top: 2px;">{{item.name}}</p>
            </template>

          </v-treeview>


        </div>

        <div style="padding:0 31px 0 38px;margin-top:23px;display:flex;align-items:center;color:#000000;">

          <p style="font-size:16px;">导出类型</p>

          <v-select v-model="exportType" :items="exportTypeList" :menu-props="{'nudgeBottom':40}"
                    placeholder="请选择导出数据类型" dense outlined hide-details
                    style="width:60px;height:36px;margin-left:20px;font-size:14px;">
          </v-select>

          <v-spacer></v-spacer>
          <v-btn @click="exportFolder" width="100" height="33" dark :color="chooseItem.length!==0 && exportType!=='' ? '#1E3A8A' : 'rgba(30, 58, 138, 0.5)'">确定</v-btn>
        </div>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  name: "ExportGlobeOperationFolder",
  props:["dialogShow"],
  data(){
    return{

      contentList:[],
      contentInit:false,

      chooseItem:[],

      exportTypeList:["KML","KMZ","Shp"],
      exportType:"",




    }

  },
  computed:{
    // //根据标记的type获取列表中名称前图标
    // getPrependIconByType(){
    //   return function (type){
    //     switch(type){
    //       case "point":{
    //         return "&#xe62d;"
    //       }
    //       case "lineString":{
    //         return "&#xe669;"
    //       }
    //       case "circle":{
    //         return "&#xe670;"
    //       }
    //       case "polygon":{
    //         return "&#xe668;"
    //       }
    //       case "rectangle":{
    //         return "&#xe66e;"
    //       }
    //       case "roadString":{
    //         return "&#xe661;"
    //       }
    //       case "administrativeArea":{
    //         return "&#xe663;"
    //       }
    //
    //
    //     }
    //
    //
    //   }
    //
    // },
    //根据标记的type获取列表中标记类型
    getTypeTextByType(){
      return function (type){
        switch(type){
          case "point":{
            return "点位标记"
          }
          case "lineString":{
            return "直线标记"
          }
          case "circle":{
            return "圆形标记"
          }
          case "polygon":{
            return "多边形标记"
          }
          case "rectangle":{
            return "矩形标记"
          }
          case "roadString":{
            return "路线规划"
          }
          case "administrativeArea":{
            return "行政区域"
          }


          case "folder":{
            return " - "
          }
          case "root":{
            return "标记类型"
          }
        }


      }

    }

  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },



    //确定导出
    exportFolder(){
      //获取选中要导出的树结构数据
      if(this.exportType!==''){
        let exportList = [];
        this.getTreeList(this.contentList[0].children,exportList)

        this.$axios({
          method:"post",
          url:"/authorApi/z-geo-file/fileExport",
          data:{
            fileId:this.$store.state.currFolderId,
            fileName:this.$store.state.currFolderName,
            exportFormat:this.exportType,
            content:exportList
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          console.log(resultData)
          if(resultData.status === 200){
            this.$emit("exportFolderOk",JSON.stringify(resultData.data))
          }
          else if(resultData.status === 308){
            this.errorShow = true;
          }
          else{
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = resultData.message
            this.$store.state.snackbarType = 'error'
          }
        }).catch(()=>{
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = "暂无权限，请联系创建者"
          this.$store.state.snackbarType = 'error'

        });
      }


    },
    //获取选中要导出的树结构数据
    getTreeList(treeList,newTreeList) {
      for(let i=0;i<treeList.length;i++){

        if(treeList[i].type === "folder" && treeList[i].children &&  treeList[i].children.length>0){
          //是目录 同时有孩子
          let tempData=JSON.parse(JSON.stringify(treeList[i]))
          tempData.children=[]
          this.getTreeList(treeList[i].children,tempData.children)
          newTreeList.push(tempData)
        }
        else if(treeList[i].type !== "folder"){
          //是标记
          for(let j=0;j<this.chooseItem.length;j++){
            if(this.chooseItem[j] === treeList[i].id){
              let tempData=JSON.parse(JSON.stringify(treeList[i]))
              newTreeList.push(tempData)
              break;
            }
          }
        }
        else{
          //是目录，但是没有孩子

        }

      }

      //孩子都没选中的目录 移除
      for(let i=newTreeList.length - 1;i >= 0;i--){
        if(newTreeList[i].type === "folder" && newTreeList[i].children.length === 0){
          newTreeList.splice(i,1)
        }
      }

    },




    // //修改列表的缩进
    // changeTreeviewLevel(){
    //   let treeLevel2 = document.querySelector(".markerFolderDataTree").querySelectorAll(".v-treeview-node__level");
    //
    //   for(let j=0;j<treeLevel2.length;j++){
    //     let nextBro_treeviewNodeContent = "";
    //     let broList = treeLevel2[j].parentNode.children
    //     for(let i=0;i<broList.length;i++){
    //
    //       //获取该level后面的v-treeview-node__content兄弟，level需要移动到该兄弟之前
    //       //因为文件夹的前面隐藏了打开关闭按钮，所以非文件夹元素需要删除掉一个level保持对齐
    //       if(broList[i].getAttribute("class") === "v-treeview-node__content"){
    //         nextBro_treeviewNodeContent = broList[i];
    //
    //         if(nextBro_treeviewNodeContent.querySelector(".v-treeview-node__prepend").querySelector("p").getAttribute("class").indexOf("prependIconFolder") === -1){
    //           //不是文件夹，需要减少一个level
    //           let nextBor = treeLevel2[j].nextElementSibling;
    //           if(nextBor.getAttribute("class") === "v-treeview-node__level"){
    //             //下一个兄弟仍然是level，移动该level到content元素之前
    //             treeLevel2[j].parentNode.insertBefore(treeLevel2[j],nextBro_treeviewNodeContent)
    //           }
    //           else{
    //             //是最后一个level，删除
    //             treeLevel2[j].remove()
    //           }
    //         }
    //         else{
    //           //是文件夹，level移动到content元素之前
    //           treeLevel2[j].parentNode.insertBefore(treeLevel2[j],nextBro_treeviewNodeContent)
    //         }
    //
    //         break;
    //       }
    //     }
    //
    //   }
    // },
    //
    // //树的最外层修改成表头
    // changeTreeviewHeader(){
    //   let firstTreeviewNode = document.querySelector(".markerFolderDataTree").querySelector(".v-treeview-node");
    //   //第一个根节点，即表头
    //   let firstTreeviewNode_root = firstTreeviewNode.querySelector(".v-treeview-node__root")
    //   firstTreeviewNode_root.style.position = "fixed";
    //   firstTreeviewNode_root.style.width = "720px";
    //   firstTreeviewNode_root.style.zIndex = "1";
    //   firstTreeviewNode_root.style.background = "#ffffff";
    //   //第一个孩子区域，即除表头外的内容列表
    //   let firstTreeviewNode_children = firstTreeviewNode.querySelector(".v-treeview-node__children")
    //   firstTreeviewNode_children.style.paddingTop = "44px";
    // },



    //拼接导出弹窗中的数据结构，删除行政区类型的数据
    getData(){
      let deleteAutonomousRegionDataList = [];
      this.$utils.markerFolderDeleteAutonomousRegion(this.$store.state.globeOperationMarkerList,deleteAutonomousRegionDataList)

      this.contentList = [
        {
          id: -1,
          geoJson:{},
          name:"标记名称",
          type:"root",
          children: deleteAutonomousRegionDataList,
        },
      ]

    },
    // deleteAutonomousRegion(treeList,newTreeList) {
    //   for(let i=0;i<treeList.length;i++){
    //     if(treeList[i].type === "folder" && treeList[i].children &&  treeList[i].children.length>0){
    //       //是目录 同时有孩子
    //       let tempData=JSON.parse(JSON.stringify(treeList[i]))
    //       tempData.children=[]
    //       this.deleteAutonomousRegion(treeList[i].children,tempData.children)
    //       newTreeList.push(tempData)
    //     }
    //     else if(treeList[i].type !== "folder"){
    //       //是标记
    //       if(treeList[i].type !== "administrativeArea"){
    //         //非行政区
    //         let tempData=JSON.parse(JSON.stringify(treeList[i]))
    //         newTreeList.push(tempData)
    //       }
    //     }
    //     else{
    //       //是目录，但是没有孩子
    //
    //     }
    //
    //   }
    //
    //   //孩子都没选中的目录 移除
    //   for(let i=newTreeList.length - 1;i >= 0;i--){
    //     if(newTreeList[i].type === "folder" && newTreeList[i].children.length === 0){
    //       newTreeList.splice(i,1)
    //     }
    //   }
    //
    // },


  },
  mounted(){
    this.getData()
    this.contentInit = true;
    console.log(this.contentList)
    if(this.$store.state.globeOperationMarkerList.length > 0){
      setTimeout(()=>{
        this.$utils.markerFolderChangeTreeviewLevel("exportFolderDataTree");
        this.$utils.markerFolderChangeTreeviewHeader("exportFolderDataTree");
      },0)
    }



  }


}
</script>

<style scoped>

.markerFolderDataTree{
  position:relative;
  width:100%;
  flex:1;
  overflow:auto;
  padding:0 38px;
}

</style>

